import { IntermediaryIdentity } from "shared/models/IntermediaryIdentity";
import { IntermediaryIdentityDto } from "tasksBoard/service/api/IntermediaryIdentityDto";

export class IntermediaryIdentityFromResponse {
    constructor(private intermediaryIdentityFromResponse: IntermediaryIdentityDto) {}

    intermediaryIdentity(): IntermediaryIdentity {
        return {
            businessSymbol: this.intermediaryIdentityFromResponse.businessSymbol,
            name: this.intermediaryIdentityFromResponse.name,
        };
    }
}
